import React from 'react';
import FeatureCard from './FeatureCard';
import { Container } from '@/components/ui/container';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { getColor } from '@/config/theme';

export function WhyChooseUs() {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <Container>
        <Stack spacing="xl" align="center" className="text-center mb-12">
          <Heading level="h2" className="text-3xl md:text-4xl font-bold">
            Why Choose Us?
          </Heading>
          <Text size="lg" variant="muted" className="max-w-3xl">
            At AI Evaluator, we are redefining the way hiring works with the power of Artificial Intelligence.
            Our platform is designed to simplify and enhance recruitment processes, making them smarter, faster,
            and more efficient. By integrating cutting-edge AI technologies, we help companies uncover top talent
            while saving time and resources.
          </Text>
          <Button
            style={{
              backgroundColor: getColor('primary'),
              color: getColor('primaryForeground'),
            }}
          >
            Learn more
          </Button>
        </Stack>
        
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
          {/* Left Feature Grid */}
          <div className="flex-1 flex flex-col gap-6 w-full lg:w-auto">
            <FeatureCard
              title="AI-Powered Recruitment"
              description="Revolutionize hiring with advanced AI technologies tailored for modern recruitment needs."
            />
            <FeatureCard
              title="User-Friendly Interface"
              description="Designed with simplicity and functionality, ensuring a smooth experience for HR teams and candidates alike."
            />
            <FeatureCard
              title="Seamless Process"
              description="Combine screening, testing, and candidate management into one unified platform."
            />
          </div>
          
          {/* Center Image */}
          <div className="flex-shrink-0 hidden lg:block">
            <img 
              src="/phone2.png" 
              alt="Hero Image" 
              className="w-full max-w-xs object-contain"
            />
          </div>
          
          {/* Right Feature Grid */}
          <div className="flex-1 flex flex-col gap-6 w-full lg:w-auto">
            <FeatureCard
              title="Smart Recording Solutions"
              description="Record, save, and review interviews seamlessly with intelligent audio and video tools."
            />
            <FeatureCard
              title="Future-Ready Tool"
              description="Equip your organization with the tools needed to adapt and help in Faster Hiring."
            />
            <FeatureCard
              title="Commitment to Innovation"
              description="Constantly evolving tools to redefine the future of hiring and talent acquisition."
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default WhyChooseUs;